import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import type AccountFacilityView from '@UI/Store/AccountFacilities/Views/AccountFacilityView';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly facilities: readonly AccountFacilityView[] | null;
	readonly withLabel?: boolean;
};

const FacilityFilter: React.FC<Props> = ({ facilities, withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);

	const handleChange = React.useCallback((selectedId: number | null) => {
		setAuditTrailFilters(auditTrailFiltersSignal.peek().setFacilityId(selectedId));
	}, []);

	return (
		<Dropdown<number>
			name="auditTrailFacility"
			label="Agence"
			isLabelHidden={!withLabel}
			placeholder="Toutes les agences"
			options={facilities ?? []}
			optionLabel="name"
			optionValue="id"
			loading={facilities === null}
			showClear
			value={currentFilters.facilityId}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default FacilityFilter;
